import { useState } from "react"
import { getArchivosData, getIntroduccionData } from "../api/capacitacion";
import { ArchivosDto, IntroduccionDto } from "../models/Capacitacion.model";

export const useCapacitacion = () => {
    const [introduccion, setIntroduccion] = useState<IntroduccionDto[]>([]);
    const [archivos, setArchivos] = useState<ArchivosDto[]>([]);

    const getIntroduccion = async () => {
        try {
          const data = await getIntroduccionData();
          setIntroduccion(data);
        } catch (err) {
          console.warn(err);
        }
      };

      const getArchivos = async () => {
        try {
          const data = await getArchivosData();
          setArchivos(data);
        } catch (err) {
          console.warn(err);
        }
      };


    return {
        getIntroduccion,
        getArchivos,
        introduccion,
        archivos
    }
}
